// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import PathSummaryHeader from './PathSummaryHeader'
import { string } from 'prop-types'
import { getUnitLabelForMetersAndFeet } from 'helpers/unitConversion'

const getHeaderLabel = ({ unitType }) => (
  `G. E. (${getUnitLabelForMetersAndFeet(unitType)})`
)

class FormatElevationHeader extends PathSummaryHeader {
  static propTypes = {
    unitType: string.isRequired,
  }

  state = {
    heading: '',
    unitType: null,
  }

  static getDerivedStateFromProps (nextProps, { unitType }) {
    return (
      nextProps?.unitType !== unitType
        ? {
          heading: getHeaderLabel(nextProps),
          unitType,
        }
        : null
    )
  }
}

export default FormatElevationHeader
